<router-outlet></router-outlet>
<app-toastr *ngIf="batteryToastrVisible"></app-toastr>